export function initTabsSticky() {
  const DEFAULT_SECTION_TOP_OFFSET_PX = 20;

  // for sticky tabs for other elements
  const tabsSection = document.querySelector('.tabs-section');
  const tabsComponent = document.querySelector('.tabs-component');
  const tabs = tabsSection || tabsComponent;
  if (!tabs) return;

  const row = tabs.closest('.fl-row');
  if (row) row.classList.add('sticky-tabs');

  // Use only tabs-section height as the sticky offset for tab jumps.
  function getStickyOffset() {
    const tabsHeight = tabs.getBoundingClientRect().height || tabs.offsetHeight || 0;
    return Math.max(0, tabsHeight);
  }

  function scrollToSectionTop(target, targetOffsetPx = 0) {
    const targetTop = target.getBoundingClientRect().top + window.scrollY;
    const scrollTop = Math.max(0, targetTop + targetOffsetPx - getStickyOffset());

    window.scrollTo({
      top: scrollTop,
      // Let CSS `scroll-behavior: smooth` drive the animation.
      behavior: 'smooth'
    });
  }

  function getSectionHeadingTarget(sectionTarget) {
    if (!sectionTarget) return null;

    const preferredHeading = sectionTarget.querySelector('.section-intro__title-wrap');
    if (preferredHeading) {
      return {
        target: preferredHeading,
        targetOffsetPx: 0
      };
    }

    return {
      target: sectionTarget,
      targetOffsetPx: DEFAULT_SECTION_TOP_OFFSET_PX
    };
  }

  // Handle tab link clicks
  document.querySelectorAll('.tabs-component .tabs-component__header-list span').forEach(function (link) {
    link.addEventListener('click', function (e) {
      const rawTarget = (this.getAttribute('data-scroll-target') || '').trim();
      const targetId = rawTarget.startsWith('#') ? rawTarget.slice(1) : rawTarget;
      if (!targetId) return;
      const sectionTarget = document.getElementById(targetId);
      if (!sectionTarget) return;
      const scrollConfig = getSectionHeadingTarget(sectionTarget);
      if (!scrollConfig || !scrollConfig.target) return;
      e.preventDefault();

      const currentItem = this.closest('li');
      const list = this.closest('.tabs-component__header-list');
      if (list && currentItem) {
        list.querySelectorAll('li.active').forEach(function (item) {
          item.classList.remove('active');
        });
        currentItem.classList.add('active');
      }

      scrollToSectionTop(scrollConfig.target, scrollConfig.targetOffsetPx);
    });
  });
}